import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { KeyValue } from '../../../models/keyvalue.model';


@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
,  standalone: false
})
export class DropdownComponent implements OnInit {
    @Input() dataList: KeyValue<string, string>[] = [];
    @Input() allowMultipleSelect: boolean = false;
    @Input() allowSearch: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() placeHolder: string = "";
    @Output() itemSelect: EventEmitter<KeyValue<string, string>> = new EventEmitter();
    @Output() selectedAll: EventEmitter<boolean>=new EventEmitter();

    dropdownList = [];
    selectedItems = [];
    dropdownSettings: IDropdownSettings = {};

    ngOnInit() {
        this.dropdownList = this.dataList;     
        this.dropdownSettings = {
            singleSelection: !this.allowMultipleSelect,
            idField: 'key',
            textField: 'value',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: this.allowSearch            
        };
    }
  onItemSelect(item: any) {
    item.isDisabled = true;
        this.itemSelect.emit(item);
  }
  onItemDeSelect(item: any) {
    item.isDisabled = false;
    this.itemSelect.emit(item);
  }
  onSelectAll(items: any) {
      this.selectedAll.emit(true);
    }
  onDeSelectAll(items: any) {
    //items.forEach((item) => {
    //  item.isDisabled = false;
    //  this.itemSelect.emit(item);
    //});
        this.selectedAll.emit(false);
    }


}
